export default {"src":"/_next/static/media/meal.60e7ac35.svg","height":152,"width":152};